import { paths } from '@apiSchema';
import { SavedSelection } from '@pages/Home/context/TerritorySelectionContext';

type ChartParams = NonNullable<
    paths['/api/SalesWorkspace/GetRestaurantOpeningsClosings']['get']['parameters']['query']
>;
type ExportParams = NonNullable<
    paths['/api/SalesWorkspace/GetRestaurantOpeningsClosingsExport']['get']['parameters']['query']
>;

type IsMutuallyAssignable<A, B> = [A] extends [B] ? ([B] extends [A] ? true : false) : false;
type AssertTrue<T extends true> = T;
type ChartAndExportAcceptTheSameQuery = AssertTrue<IsMutuallyAssignable<ChartParams, ExportParams>>;

export type OpeningsClosingsParams = ChartParams;

export interface OpeningsClosingsQuery {
    savedSelection: SavedSelection | null;
    segments: string[];
    cuisines: string[];
    chainSizes: string[];
}

export const buildOpeningsClosingsParams = (
    query: OpeningsClosingsQuery,
): OpeningsClosingsParams => {
    const { savedSelection, segments, cuisines, chainSizes } = query;
    const params: OpeningsClosingsParams = {};

    if (savedSelection && savedSelection.ids.length > 0) {
        if (savedSelection.mode === 'state') {
            params.states = savedSelection.ids;
        } else {
            params.metros = savedSelection.ids.map(Number);
        }
    }
    if (segments.length > 0) params.segments = segments;
    if (cuisines.length > 0) params.cuisines = cuisines;
    if (chainSizes.length > 0) params.chainSizes = chainSizes;

    return params;
};
